import api from "@checkout/services/api";
import router from "@checkout/router";
import localStorage from "@checkout/services/storage";

export default {
  name: "ThankYou",

  data() {
    return {
      solvent: true,
      isLoading: false,
    };
  },

  mounted() {
    this.prepareStep7();
  },

  methods: {
    prepareStep7() {
      this.isLoading = true;
      api
        .get("/public-api/prepare/7/" + localStorage.get("page-step", true))
        .then((response) => {
          this.solvent = response.data.solvent;
          this.isLoading = false;
        })
        .catch((error) => {
          this.$swal(this.$i18nApi.t("messages.error"));
          this.isLoading = false;
        });
    },
  },
};
